import React from 'react';
import { EventContentArg } from '@fullcalendar/core';
import { Stack, Typography } from '@mui/material';
import { getDealStatusColor } from 'helpers/getStatusColor';
import { QueryObserverResult } from '@tanstack/react-query';
import BrandChip from '../../Chips/BrandChip';
import TooltipChip from '../../Chips/TooltipChip';
import EventCommentDialog from './EventCommentDialog';

interface Props {
  eventInfo: EventContentArg;
  refetch: () => Promise<QueryObserverResult>;
}

const EventContent = (props: Props): JSX.Element | null => {
  const { eventInfo, refetch } = props;

  return (
    <Stack
      direction="row"
      columnGap={0.5}
      sx={{ '&:hover': { cursor: 'pointer' } }}
    >
      <BrandChip
        brand={eventInfo.event.extendedProps.brand}
        onlyLogo
        ChipProps={{
          sx: {
            '&:hover': { cursor: 'pointer' },
          },
        }}
      />
      <TooltipChip
        title={
          <Stack>
            <Typography>
              {`Status: `}
              <Typography variant="body2" component="span">
                {eventInfo.event.extendedProps.status}
              </Typography>
            </Typography>
            <Typography>
              {`Influncer: `}
              <Typography variant="body2" component="span">
                {eventInfo.event.title}
              </Typography>
            </Typography>
          </Stack>
        }
        label={eventInfo.event.title}
        color={getDealStatusColor(eventInfo.event.extendedProps.status)}
        sx={{
          width: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          '&:hover': {
            cursor: 'pointer',
          },
        }}
      />
      <EventCommentDialog
        data={eventInfo.event.extendedProps as any}
        refetch={refetch}
      />
    </Stack>
  );
};

export default EventContent;
